import { observer } from "mobx-react-lite";
import React from "react";
import { OcrService } from "../../services/ocr/OcrService";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import { Grid, Stack, Typography } from "@mui/material";
import { translationService } from "../../services/translation/TranslationService";

export default observer(function ReportLoader(props:{ocr: OcrService, children: any}) {
    return (
        <>
            <Grid item xs={12} sm={8} className="centered">
                {props.ocr.ocrRunning && 
                    <Stack>
                        <LoadingSpinner />
                        <Typography>{translationService.translate("ocrService.state.inProgress")}</Typography>
                    </Stack>
                }
                {props.ocr.ocrFailed && <Typography color="red" >{props.ocr.errorMessage}</Typography>}
            </Grid>
            {props.ocr.ocrSuccessful && props.children}
        </>
    )
})